import { useCallback, useEffect, useRef, useState } from 'react'
import type { SlashMenuPosition } from './SlashMenu'

export const useSlashMenuState = () => {
  const [position, setPosition] = useState<SlashMenuPosition | null>(null)
  const [filter, setFilter] = useState('')
  const positionRef = useRef(position)
  positionRef.current = position

  const close = useCallback(() => {
    setPosition(null)
    setFilter('')
  }, [])

  useEffect(() => {
    if (!position) return
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      if (!target.closest('.slash-menu') && !target.closest('.notion-editor')) {
        close()
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [position, close])

  return { position, setPosition, filter, setFilter, positionRef, close }
}
